(ns dre.app.search.query-shared
  (:require
   [dre.shared.interface.search.blunt :as blunt]
   [dre.util :refer [unkeyword]]))

(def blunt-types
  "A set of search query types with BLUNT queries"
  #{:articles :blunt :effects :guidances :regdocs})

(defn skw
  "Returns a keyword k with optional idx suffix."
  ([k]
   (skw k nil))
  ([k idx]
   (let [idx (or idx 0)
         suffix (if (zero? idx) "" (str (inc idx)))]
     (keyword (str (unkeyword k) suffix)))))

(def default-search-type
  "A default search query type"
  :articles)

(defn- baq-from-query-params
  [query-params idx]
  (when-let [baq-type (:baq-topic query-params)]
    {:topic baq-type
     :starttime (:baq-starttime query-params)
     :categories (for [i (range 10)
                       :let [category-idx (inc i)]
                       :while (contains? query-params (skw (str "baq-category-" category-idx "-type") idx))]
                   {:type (get query-params (skw (str "baq-category-" category-idx "-type") idx))
                    :blunt (get query-params (skw (str "baq-category-" category-idx "-blunt") idx))})}))

(defn search-query
  "Returns a search query from a given route.
  A pills query is returned as blueprints and must be completed."
  ([route]
   (search-query route nil))
  ([route idx]
   (let [qp (or (:query-params route) route)
         type (keyword (get qp (skw "type" idx) default-search-type))
         query (get qp (skw "query" idx))
         query-free-text (get qp (skw "free-text-query" idx))
         order (get qp (skw "order" idx))
         viewtype (keyword (get qp (skw "viewtype" idx) :default))
         question (get qp (skw "question" idx))
         baq (baq-from-query-params qp idx)
         search-query {:query/type type, :query/query query :query/free-text query-free-text
                       :query/order order :query/viewtype viewtype :query/question question :query/baq baq}]
     (if (contains? blunt-types type)
       (assoc search-query :query/blueprints (blunt/parse query))
       search-query))))
